import { Fragment, useContext, useEffect } from 'react'

import { FilterBody } from '../../../FilterModal'
import AdultAgeRender from './AdultAge'
import ChildrenAgeRender from './ChildrenAge'
import PaxAlert from './PaxAlert'
import { PAXContext } from './PaxContext'
import PaxRoom from './PaxRoom'

export const PaxAgeComponent = ({ onChange }) => {
	const [{ costingInfo = [] }] = useContext(PAXContext)

	useEffect(() => {
		typeof onChange === 'function' && onChange(costingInfo)
	}, [costingInfo, onChange])

	return (
		<Fragment>
			<PaxAlert />
			<FilterBody bottom={'48px'}>
				<PaxRoom color={'#148099'} />
				<AdultAgeRender template={'PACKAGE_V2'} />
				<ChildrenAgeRender template={'PACKAGE_V2'} />
			</FilterBody>
		</Fragment>
	)
}
